import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const StrikethroughIcon = (props?: SvgProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M12 3H6.74996C6.3899 2.99981 6.03506 3.08604 5.71524 3.25143C5.39542 3.41682 5.11996 3.65655 4.912 3.95048C4.70405 4.24441 4.56967 4.58396 4.52016 4.94059C4.47064 5.29723 4.50744 5.66054 4.62746 6"
      stroke="#6B7280"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.5 9C11.2956 9 12.0587 9.31607 12.6213 9.87868C13.1839 10.4413 13.5 11.2044 13.5 12C13.5 12.7956 13.1839 13.5587 12.6213 14.1213C12.0587 14.6839 11.2956 15 10.5 15H4.5"
      stroke="#6B7280"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 9H15"
      stroke="#6B7280"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
